module.exports = __webpack_public_path__ + "img/IMG_8157_L_WoodMatted.2ecda8a6.jpg";